import { useEffect, useState } from 'react'
import { useNavbarClockPreferences } from '../hooks/useNavbarClockPreferences'
import {
  NAVBAR_CLOCK_FONT_OPTIONS,
  NAVBAR_CLOCK_SIZE_OPTIONS,
} from '../lib/navbarClockPreferences'
import { getActiveThemeMode } from '../lib/themeBuilder'

function twoDigits(value) {
  return String(value).padStart(2, '0')
}

export function formatLocalTime(date) {
  return [
    twoDigits(date.getHours()),
    twoDigits(date.getMinutes()),
    twoDigits(date.getSeconds()),
  ].join(':')
}

export default function NavbarClock() {
  const [now, setNow] = useState(() => new Date())
  const [activeThemeMode, setActiveThemeMode] = useState(getActiveThemeMode)
  const { preferences } = useNavbarClockPreferences()

  useEffect(() => {
    let timerId
    const scheduleNextSecond = () => {
      const delay = 1000 - (Date.now() % 1000)
      timerId = window.setTimeout(() => {
        setNow(new Date())
        scheduleNextSecond()
      }, delay)
    }
    scheduleNextSecond()

    return () => window.clearTimeout(timerId)
  }, [])

  useEffect(() => {
    const syncThemeMode = () => setActiveThemeMode(getActiveThemeMode())

    window.addEventListener('bwc-theme-change', syncThemeMode)
    window.addEventListener('storage', syncThemeMode)
    return () => {
      window.removeEventListener('bwc-theme-change', syncThemeMode)
      window.removeEventListener('storage', syncThemeMode)
    }
  }, [])

  const formattedTime = formatLocalTime(now)
  const size = NAVBAR_CLOCK_SIZE_OPTIONS.find(option => option.value === preferences.size)
  const font = NAVBAR_CLOCK_FONT_OPTIONS.find(option => option.value === preferences.font)
  const activeColor = preferences.colors[activeThemeMode]

  return (
    <time
      data-testid="navbar-clock"
      dateTime={now.toISOString()}
      aria-label={`Local time ${formattedTime}`}
      aria-live="off"
      title="Local time"
      className={`hidden h-8 shrink-0 items-center justify-end text-ink opacity-75 font-medium tracking-widest tabular-nums xl:inline-flex ${size.className} ${font.className}`}
      style={activeColor ? { color: activeColor } : undefined}
    >
      {formattedTime}
    </time>
  )
}
